import { useMemo } from 'react'
import { createMemoryRouter, RouterProvider } from 'react-router'
import { AppShell } from './AppShell'
import { RouterErrorBoundary } from './components/ErrorFallback/RouterErrorBoundary'
import { Files, Home, Prompts } from './pages'
import { ProtectedRoute } from './ProtectedRoute'

interface AppRouterProps {
  initialEntries?: string[]
}

const AppRouter = ({ initialEntries }: AppRouterProps = {}) => {
  const router = useMemo(
    () =>
      createMemoryRouter(
        [
          {
            path: '/',
            element: (
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            ),
            errorElement: <RouterErrorBoundary />,
            children: [
              {
                index: true,
                element: <Home />,
              },
              {
                path: 'files',
                element: <Files />,
              },
              {
                path: 'prompts',
                element: <Prompts />,
              },
            ],
          },
        ],
        {
          initialEntries,
        }
      ),
    [initialEntries]
  )

  return <RouterProvider router={router} />
}

export { AppRouter }
